import * as React from "react";

const ToastContext = React.createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = React.useState([]);
  const [toastMessage, setToastMessageState] = React.useState(null);
  const toastIdRef = React.useRef(0);

  const setToastMessage = (message) => {
    if (!message) {
      // Handle clearing behavior for compatibility
      setToastMessageState(null);
      return;
    }

    // Update the single toast message for backward compatibility
    setToastMessageState(message);

    // Add to the toast array
    const newId = toastIdRef.current++;
    setToasts((prevToasts) => [...prevToasts, { id: newId, message }]);

    // Auto-remove toast after 3 seconds
    setTimeout(() => {
      setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== newId));

      // Clear the single toast state if this was the last toast
      setToastMessageState((prev) => (prev === message ? null : prev));
    }, 3000);
  };

  const clearToasts = () => {
    setToasts([]);
    setToastMessageState(null);
  };

  return (
    <ToastContext.Provider
      value={{
        toasts,
        toastMessage, // Keep for backward compatibility
        setToastMessage,
        clearToasts,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return React.useContext(ToastContext);
}
